import { csrfInterceptor } from "@sazka/utils/http-clients/csrf-interceptor";
import axios, { AxiosRequestConfig } from "axios";
import { BusinessCardResponse, BusinessCardResponseWithData } from "../models/business-card-data";

export interface Bank {
    id: string;
    name: string;
    logo: string;
}

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: "/api",
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const businessCardHttpClient = axios.create(config);
businessCardHttpClient.interceptors.request.use(csrfInterceptor, null, { synchronous: true });

const getBankList = async () => {
    const response = await businessCardHttpClient.get<Bank[]>("/registration/bank-id/banks", {});
    return response.data;
};

const getBusinessCardData = async (code: string) => {
    const response = await businessCardHttpClient.get<BusinessCardResponseWithData>(
        `/registration/bank-id/data?code=${code}`
    );
    return response.data;
};

const checkBusinessCardData = async (code: string, fromPopup: boolean) => {
    const response = await businessCardHttpClient.put<BusinessCardResponse>(
        `/registration/bank-id/check?code=${code}&fromPopup=${fromPopup}`,
        null,
        {}
    );
    return response.data;
};

export { getBankList, getBusinessCardData, checkBusinessCardData };
